export { default as PeopleTab } from './src/people-tab';
